<script>
    export let showError = false;
    export let showSuccess = false;
    export let showCheckmark = false;
    export let showLoading = false;
</script>

{#if showError}
    <u class="state invalid">
        <svg class="icon" viewBox="0 0 10 10">
            <path d="M5.80084 6.36083L6.1325 0H3.88L4.2125 6.36083H5.80084Z" />
            <path
                d="M5 10C5.69036 10 6.25 9.44036 6.25 8.75C6.25 8.05964 5.69036 7.5 5 7.5C4.30964 7.5 3.75 8.05964 3.75 8.75C3.75 9.44036 4.30964 10 5 10Z"
            />
        </svg>
    </u>
{/if}

{#if showCheckmark && showSuccess}
    <u class="state success">
        <svg class="icon" viewBox="0 0 10 10">
            <path
                d="M8.57751 1.07768L3.33335 6.32184L1.42251 4.41101C1.26535 4.25921 1.05484 4.17522 0.836346 4.17711C0.617849 4.17901 0.408838 4.26665 0.254332 4.42116C0.0998249 4.57567 0.0121841 4.78468 0.0102854 5.00318C0.00838673 5.22167 0.0923821 5.43217 0.24418 5.58934L2.74418 8.08934C2.90045 8.24557 3.11238 8.33333 3.33335 8.33333C3.55432 8.33333 3.76624 8.24557 3.92251 8.08934L9.75585 2.25601C9.90765 2.09884 9.99164 1.88834 9.98974 1.66984C9.98784 1.45134 9.9002 1.24233 9.7457 1.08783C9.59119 0.933321 9.38218 0.84568 9.16368 0.843782C8.94518 0.841883 8.73468 0.925878 8.57751 1.07768Z"
            />
        </svg>
        <svg class="lines" viewBox="0 0 40 40">
            <path d="M20 8V2" />
            <path d="M32 20H38" />
            <path d="M20 32V38" />
            <path d="M8 20H2" />
            <path d="M10.5 10.5L6.5 6.5" />
            <path d="M29.5 10.5L33.5 6.5" />
            <path d="M10.5 29.5L6.5 33.5" />
            <path d="M29.5 29.5L33.5 33.5" />
        </svg>
    </u>
{/if}

{#if showLoading}
    <u class="state">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            style="margin: auto; background: none; display: block; shape-rendering: auto;"
            width="20px"
            height="20px"
            viewBox="0 0 100 100"
            preserveAspectRatio="xMidYMid"
        >
            <circle
                cx="50"
                cy="50"
                fill="none"
                stroke="#c8cace"
                stroke-width="8"
                r="40"
                stroke-dasharray="100 60"
            >
                <animateTransform
                    attributeName="transform"
                    type="rotate"
                    repeatCount="indefinite"
                    dur="1s"
                    values="0 50 50;360 50 50"
                    keyTimes="0;1"
                />
            </circle>
        </svg>
    </u>
{/if}

<style lang="scss">
    $error-color: #ef444a;

    u {
        position: absolute;
        transition: all 100ms ease-in-out;

        &.state {
            width: 20px;
            height: 20px;
            position: absolute;
            top: 22px;
            right: 22px;
            display: flex;
            justify-content: center;
            align-items: center;
            pointer-events: none;

            &.success {
                .lines {
                    display: block;
                    width: 36px;
                    height: 36px;
                    position: absolute;
                    left: -8px;
                    top: -8px;
                    stroke-dasharray: 7px;
                    stroke-dashoffset: 21px;
                    stroke: #41dd6d;
                    stroke-width: 1.1px;
                    stroke-linecap: round;
                    animation: success-lines 0.4s cubic-bezier(0.16, 1, 0.3, 1) 0.2s;
                }

                .icon {
                    width: 20px;
                    height: 20px;
                    fill: #41dd6d;
                    transform: scale(1) translateZ(0);
                    animation: success-tick 1s cubic-bezier(0.16, 1, 0.3, 1) forwards;
                }
            }

            &.invalid {
                opacity: 1;
                animation: show-error 2s cubic-bezier(0.33, 1, 0.68, 1) forwards;

                &:before {
                    content: '';
                    left: 0;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    position: absolute;
                    border-radius: 50%;
                    transform: scale(0, 0) translate3d(0, 0, 0);
                    background-color: #ebedf0;
                    animation: show-error-circle 0.5s cubic-bezier(0.33, 1, 0.68, 1) 0.1s forwards;
                }

                .icon {
                    width: 10px;
                    position: relative;
                    z-index: 1;
                    fill: #fff;
                    opacity: 0;
                    transform: scale(0) translateZ(0);
                    animation: show-error-inner 0.5s cubic-bezier(0.33, 1, 0.68, 1) 0.45s forwards;
                }
            }
        }
    }

    @keyframes show-error {
        from {
            opacity: 1;
            transform: translate3d(0, 28px, 0);
        }

        33% {
            transform: translate3d(0, -2px, 0);
            opacity: 1;
        }

        66% {
            transform: translate3d(0, 2px, 0);
            opacity: 1;
        }

        to {
            transform: translate3d(0, 0, 0);
            opacity: 1;
        }
    }

    @keyframes show-error-circle {
        33% {
            transform: scale(0.7, 1.1) translate3d(0, 0, 0);
        }

        33%,
        100% {
            background-color: $error-color;
        }

        66% {
            transform: scale(1.05, 0.95) translate3d(0, 0, 0);
        }

        100% {
            transform: translate3d(0, 0, 0);
            background-color: $error-color;
        }
    }

    @keyframes show-error-inner {
        to {
            opacity: 1;
            transform: scale(1, 1) translate3d(0, 0, 0);
        }
    }

    @keyframes success-tick {
        0% {
            transform: scale(0);
        }
        50% {
            transform: scale(1.1);
        }
        75% {
            transform: scale(0.9);
        }
        100% {
            transform: scale(1) translateZ(0);
        }
    }

    @keyframes success-lines {
        to {
            stroke-dashoffset: 7px;
        }
    }
</style>
